// Admin: list of leads (email unique). Each row links to lead detail page.

import { Link } from 'react-router-dom';
import { useLeads } from '@/hooks/use-store';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

export default function AdminLeads() {
  const { data: leads, isLoading } = useLeads();

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Leads</h1>
      <p className="text-secondary mb-4">One row per email. Quotation requests are linked to leads.</p>
      {isLoading ? (
        <p className="text-secondary">Loading...</p>
      ) : (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Email</TableHead>
              <TableHead>Name</TableHead>
              <TableHead>Phone</TableHead>
              <TableHead>Company</TableHead>
              <TableHead>Country</TableHead>
              <TableHead>City</TableHead>
              <TableHead>Created</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {(leads ?? []).map((lead) => (
              <TableRow key={lead.id} className="hover:bg-zinc-50/50">
                <TableCell>
                  <Link to={`/store/admin/leads/${lead.id}`} className="text-primary hover:underline">
                    {lead.email}
                  </Link>
                </TableCell>
                <TableCell>{lead.name ?? '—'}</TableCell>
                <TableCell>{lead.phone ?? '—'}</TableCell>
                <TableCell>{lead.company ?? '—'}</TableCell>
                <TableCell>{lead.country ?? '—'}</TableCell>
                <TableCell>{lead.city ?? '—'}</TableCell>
                <TableCell>{new Date(lead.created_at).toLocaleDateString()}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
}
